module.exports = __webpack_public_path__ + "build/img/banner1.56eb368d.jpg";